import { CategoryData } from '../../../../types/types';

export const salutations: CategoryData = {
    // Salutations de base
    'I ni ce': {
        translation: 'Bonjour',
        translationEn: 'Hello',
        illustration: '👋',
        audio: 'Ba-i_ni_ce',
        displayName: 'I ni ce'
    },
    'I ni sogoma': {
        translation: 'Bonjour (le matin)',
        translationEn: 'Good morning',
        illustration: '🌅',
        audio: 'Ba-i_ni_sogoma',
        displayName: 'I ni sogoma'
    },
    'I ni tile': {
        translation: 'Bonjour (dans la journée)',
        translationEn: 'Good afternoon (during the day)',
        illustration: '☀️',
        audio: 'Ba-i_ni_tile',
        displayName: 'I ni tile'
    },
    'I ni su': {
        translation: 'Bonsoir',
        translationEn: 'Good evening',
        illustration: '🌙',
        audio: 'Ba-i_ni_su',
        displayName: 'I ni su'
    },
    'K\'an ben': {
        translation: 'Au revoir',
        translationEn: 'Goodbye',
        illustration: '👋',
        displayName: 'K\'an ben'
    },
    'Ayi': {
        translation: 'Non',
        translationEn: 'No',
        illustration: '🙅🏿',
        displayName: 'Ayi'
    },

    'Sabari': {
        translation: 'Pardon',
        translationEn: 'Sorry',
        illustration: '🙏',
        audio: 'Ba-sabari',
        displayName: 'Sabari'
    },


     'Yafa n ma': {
        translation: 'Pardon',
        translationEn: 'Forgive me',
        illustration: '🙏',
        audio: 'Ba-Yafa_n_ma',
        displayName: 'Yafa n ma'
    },

    // Formules de politesse
    'I ni baraji': {
        translation: 'Merci beaucoup',
        translationEn: 'Thank you very much',
        illustration: '🙏',
        displayName: 'I ni baraji'
    },
    'Here do': {
        translation: 'S\'il vous plaît',
        translationEn: 'Please',
        illustration: '🤲',
        displayName: 'Here do'
    },
    'Haketo': {
        translation: 'Pardon/Excusez-moi',
        translationEn: 'Sorry/Excuse me',
        illustration: '🙇',
        audio: 'Ba-hake_to',
        displayName: 'Haketo'
    },

    // Questions de base
    'I ka kene?': {
        translation: 'Comment vas-tu?',
        translationEn: 'How are you?',
        illustration: '😊',
        displayName: 'I ka kene?'
    },
    'Toro te': {
        translation: 'Ça va bien (réponse)',
        translationEn: 'I\'m fine (response)',
        illustration: '👍',
        displayName: 'Toro te'
    },
    'I togo?': {
        translation: 'Comment t\'appelles-tu?',
        translationEn: 'What\'s your name?',
        illustration: '🤔',
        displayName: 'I togo?'
    },

    // Expressions courantes
    'Aw ni ce': {
        translation: 'Bonjour à tous',
        translationEn: 'Hello everyone',
        illustration: '👥',
        displayName: 'Aw ni ce'
    },
    'Ka somogo?': {
        translation: 'Comment va la famille?',
        translationEn: 'How is the family?',
        illustration: '👨‍👩‍👧‍👦',
        displayName: 'Ka somogo?'
    },
    'Here sira': {
        translation: 'Bienvenue',
        translationEn: 'Welcome',
        illustration: '🏠',
        displayName: 'Here sira'
    }
};

export default salutations;
export {};
